<div class="d-flex align-items-center justify-content-center position-relative px-4">
  <span class="text-truncate">{{ displayName() }}</span>
  <span
    class="sorting-icon"
    [ngClass]="{
      'ag-icon-asc': this.currentSorting() === 'asc',
      'ag-icon-desc': this.currentSorting() === 'desc',
      'ag-hidden': this.currentSorting() === undefined,
    }"
  ></span>
  @if (areFiltersEnabled()) {
    <apm-icon
      class="position-absolute top-50 translate-middle-y end-0"
      size="xxs"
      icon="t_filter"
      [isButton]="true"
      [ngClass]="{ 'opacity-30': !filtered() && headerHovered(), 'opacity-0': !headerHovered() && !filtered() }"
      (iconClick)="openPerformanceFilterDialog($event)"
    ></apm-icon>
  } @else if (areDefaultFiltersEnabled()) {
    @if (hasDefaultFilter()) {
      <span class="ag-icon ag-icon-filter" (click)="showDefaultFilterMenu($event)"></span>
    } @else {
      <span
        class="ag-icon ag-icon-menu menu-icon position-relative opacity-0"
        [ngClass]="{ 'opacity-100': !filtered() && headerHovered() }"
        (click)="showDefaultFilterMenu($event)"
      >
      </span>
    }
  }
</div>
